package presentation.screens.forgotPassword

import utils.UiAction
import utils.UiState

sealed interface ForgotPasswordMVIAction : UiAction {

    data class EmailChanged(val email: String) : ForgotPasswordMVIAction
    data object SendClicked : ForgotPasswordMVIAction
    data object ErrorDismissed : ForgotPasswordMVIAction
    data object BackClicked : ForgotPasswordMVIAction
}

data class ForgotPasswordState(
    val isLoading: Boolean = false,
    val isError: Boolean = false,
    val token: String? = null,
    val email: String = "",
    val isEmailError: Boolean = false,
) : UiState